import { tns } from 'tiny-slider/dist/tiny-slider';

export const initSlider = () => {
    document.querySelectorAll('.tiny-slider').forEach(slider_wrapper => {
        const inner_slider = slider_wrapper.querySelector('.tiny-slider-slider.active');

        if (!inner_slider) return;

        const slider = tns({
            container: inner_slider,
            items: 1,
            loop: true,
            autoplay: true,
            controls: false,
            autoplayButtonOutput: false,
            speed: 2000,
            autoplayTimeout: 10000,
            autoplayHoverPause: true,
            nav: false,
            ...slider_wrapper.dataset,
        });

        const fun_update_indicators = index =>
            slider_wrapper
                .querySelectorAll('[data-item]')
                .forEach(indicator => (indicator.style.opacity = parseInt(indicator.dataset.item) === index ? 1 : 0.3));

        fun_update_indicators(1);

        slider.events.on('indexChanged', e => fun_update_indicators(e.displayIndex));

        slider_wrapper
            .querySelectorAll('[data-slide-to]')
            .forEach(control => control.addEventListener('click', () => slider.goTo(control.dataset.slideTo)));
    });
};
